<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoDetalhar">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoDetalhar">
            <div class="flex justify-content-between align-items-center">
                <h4 class="m-0">{{ empresa?.nomeFantasia }}</h4>
                <button type="button" pButton icon="pi pi-pencil" label="Editar" class="p-button-outlined"
                    (click)="editarDados()">
                </button>
            </div>

            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
            </div>
            <form #f="ngForm" name="form">
                <div class="formgroup" *ngIf="loading">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                    </div>
                    <div class="flex justify-content-center">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                </div>
                <div class="formgroup" *ngIf="empresa && !loading">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-divider></p-divider>
                        </div>
                        <div class="col-12 md:col-12">
                            <h5>Dados Principais</h5>
                        </div>

                        <div class="form-group field col-12 md:col-12">
                            <div class="profile-picture-container">
                                <img [src]="croppedImage" alt="Profile Picture" class="profile-picture-circular" />
                            </div>
                            <label for="profile-picture" class="upload-icon">
                                <input type="file" id="profile-picture" (change)="fileChangeEvent($event)"
                                    accept="image/*" hidden />
                                <i class="pi pi-upload"></i>
                            </label>

                        </div>



                        <div class="form-group field col-12 md:col-6">
                            <label>Nome Empresa</label>
                            <label class="form-control">{{ empresa.nomeFantasia }}</label>
                        </div>
                        <div class="form-group field col-12 md:col-6">
                            <label>Razão Social</label>
                            <label class="form-control">{{ empresa.razaoSocial }}</label>
                        </div>
                        <div class="form-group field col-12 md:col-3">
                            <label>CNPJ</label>
                            <label class="form-control">{{ empresa.cnpj | cnpjFormat }}</label>
                        </div>

                        <div class="form-group field col-12 md:col-4">
                            <label htmlFor="email">E-mail</label>
                            <input pInputText type="email" id="campoEmail" placeholder="email@mail.com" name="email"
                                ngModel email="true" #email="ngModel" [(ngModel)]="empresa.email"
                                [readonly]="!editar" />
                            <div *ngIf="email.hasError('email')" class="alerta">
                                <small>Digite um e-mail válido</small>
                            </div>
                        </div>

                        <div class="col-12">
                            <h5>Endereço</h5>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="cep">CEP</label>
                            <p-inputMask mask="99999-999" [unmask]="true" placeholder="00000-000" name="cep" ngModel
                                #cep="ngModel" [(ngModel)]="empresa.cep" [readonly]="!editar"> </p-inputMask>
                        </div>

                        <div class="field col-12 md:col-6">
                            <label htmlFor="logradouro">Logradouro</label>
                            <input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
                                name="logradouro" ngModel #logradouro="ngModel" [(ngModel)]="empresa.logradouro"
                                [readonly]="!editar" />
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="bairro">Bairro</label>
                            <input pInputText type="text" name="bairro" ngModel
                                oninput="this.value = this.value.toUpperCase();" [(ngModel)]="empresa.bairro"
                                #bairro="ngModel" [readonly]="!editar" />
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="numero">Número</label>
                            <input pInputText type="text" name="numero" ngModel #numero="ngModel"
                                [(ngModel)]="empresa.numero" [readonly]="!editar" />
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="complemento">Complemento</label>
                            <input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
                                name="complemento" ngModel #complemento="ngModel" [(ngModel)]="empresa.complemento"
                                [readonly]="!editar" />
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="uf">Estado</label>
                            <p-dropdown [options]="listaUfs" optionLabel="label" optionValue="label" [editable]="true"
                                [filter]="true" emptyFilterMessage="Nenhum registro"
                                (onChange)="carregarMunicipios(true)" placeholder="UF" name="uf" ngModel #uf="ngModel"
                                [(ngModel)]="empresa.uf" [readonly]="!editar" [required]="true"></p-dropdown>
                        </div>

                        <div class="field col-12 md:col-7">
                            <label htmlFor="cidade">Cidade</label>
                            <p-dropdown [options]="listaMunicipios" optionLabel="label" optionValue="label"
                                [editable]="true" [filter]="true" emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione a Cidade" name="cidade" ngModel #cidade="ngModel"
                                [(ngModel)]="empresa.cidade" [readonly]="!editar" [required]="true"></p-dropdown>

                        </div>


                        <div class="col-12">
                            <h5>Contatos</h5>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="telefone">Telefone</label>
                            <p-inputMask mask="(99)9999-9999" [unmask]="true" type="text" placeholder="(00)0000-0000"
                                [(ngModel)]="empresa.telefone" name="telefone" ngModel #telefone="ngModel"
                                [readonly]="!editar">
                            </p-inputMask>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="whatsapp">Whatsapp</label>
                            <p-inputMask mask="(99)99999-9999" [unmask]="true" type="text" placeholder="(00)00000-0000"
                                [(ngModel)]="empresa.whatsapp" name="whatsapp" ngModel #whatsapp="ngModel"
                                [readonly]="!editar">
                            </p-inputMask>
                        </div>
                        <div class="col-12">
                            <h5>Tributação</h5>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="crt">CRT</label>
                            <p-dropdown [options]="crts" optionLabel="label" optionValue="value"
                                emptyFilterMessage="Nenhum registro" [(ngModel)]="empresa.crt" name="crt" ngModel
                                #crt="ngModel" [readonly]="!editar"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-2">
                            <button *ngIf="!progressoRequisicao else exibirBotaoFalso" type="button" pButton icon="pi pi-check" label="Atualizar" (click)="atualizar()"
                                class="p-button-outlined p-button-success md:w-9rem" [disabled]="!editar || f.invalid">
                            </button>
                            <ng-template #exibirBotaoFalso>
                                <button type="submit" pButton icon="pi pi-spin pi-spinner" label="Atualizando..."
                                class="p-button-outlined p-button-success md:w-9rem" disabled></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-outlined md:w-9rem" routerLink="/apps/dashboard"></button>
                        </div>
                    </div>
                </div>
            </form>

            <p-dialog header="Ajustar Logo" [(visible)]="mostrarDialogImagem" 
            [modal]="true" [style]="{width: '50vw'}"
                [draggable]="false" [resizable]="false" [closable]="false">
                <div class="card flex justify-content-center">
                    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                        [aspectRatio]="4 / 3" format="png" (imageCropped)="imageCropped($event)"
                        (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()"
                        (loadImageFailed)="loadImageFailed()"
                        [style]="{width: '40vw'}"></image-cropper>
                </div>
                <p-footer>
                    <div class="flex justify-content-between">
                        <button type="button" pButton icon="pi pi-check" label="Salvar" class="p-button-success mt-2"
                            (click)="salvarImagemLogo()"></button>

                        <button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
                            (click)="mostrarDialogImagem = false"></button>
                    </div>
                </p-footer>
            </p-dialog>
        </div>
    </div>
</div>